// TeacherHints.jsx
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./TeacherHints.module.css"; // подключи CSS-модуль
import { useSelector } from "react-redux";
import { selectAccessToken } from "../../redux/authTeacher/selector.js";
import { useTranslation } from "react-i18next";

const TeacherHints = () => {
  const teacherToken = useSelector(selectAccessToken);
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
  const { i18n, t } = useTranslation();
  const lang = i18n.language || "en";
  const titleRef = useRef();

  useEffect(() => {
    if (visible && titleRef.current) {
      titleRef.current.focus();
    }
  }, [visible]);

  useEffect(() => {
    if (!teacherToken) return; // Показывать только авторизованному преподавателю

    const dismissed = localStorage.getItem("teacherHintsDismissed");
    if (dismissed === "true") return;

    const postponedUntil = localStorage.getItem("teacherHintsPostponed");
    if (postponedUntil) {
      const now = new Date();
      const postponedDate = new Date(postponedUntil);
      if (now >= postponedDate) setVisible(true);
    } else {
      setVisible(true);
    }
  }, [teacherToken]);

  const handleDismiss = () => {
    localStorage.setItem("teacherHintsDismissed", "true");
    setVisible(false);
  };

  const handlePostpone = () => {
    const date = new Date();
    date.setDate(date.getDate() + 3);
    localStorage.setItem("teacherHintsPostponed", date.toISOString());
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      ref={titleRef}
      tabIndex={-1}
      className={styles.hintsContainer}
      role="region"
      aria-label={t("teacherHints.ariaLabel")}
    >
      <h3 className={styles.title}>🎯 {t("teacherHints.title")}</h3>
      <ul className={styles.hintList}>
        <li>
          <button
            onClick={() => navigate(`/${lang}/teacher-dashboard`)}
            className={styles.hintItem}
          >
            👤 <b>{t("teacherHints.profileTitle")}</b> —{" "}
            {t("teacherHints.profileText")}
          </button>
        </li>
        <li>
          <button
            onClick={() => navigate(`/${lang}/lesson-create`)}
            className={styles.hintItem}
          >
            🗓️ <b>{t("teacherHints.slotsTitle")}</b> —{" "}
            {t("teacherHints.slotsText")}
          </button>
        </li>
        <li>
          <button
            onClick={() => navigate(`/${lang}/teacher-dashboard/videos`)}
            className={styles.hintItem}
          >
            🎥 <b>{t("teacherHints.videoTitle")}</b> —{" "}
            {t("teacherHints.videoText")}
          </button>
        </li>
        <li>
          <button
            onClick={() => navigate(`/${lang}/teacher-dashboard/lesson-info`)}
            className={styles.hintItem}
          >
            🌍 <b>{t("teacherHints.locationTitle")}</b> —{" "}
            {t("teacherHints.locationText")}
          </button>
        </li>
        <li>
          <button
            onClick={() => navigate(`/${lang}/benefits`)}
            className={styles.hintItem}
          >
            ⭐ <b>{t("teacherHints.benefitsTitle")}</b> —{" "}
            {t("teacherHints.benefitsText")}
          </button>
        </li>
      </ul>

      <div className={styles.buttons}>
        <button onClick={handlePostpone}>{t("teacherHints.postpone")}</button>
        <button onClick={handleDismiss}>{t("teacherHints.dismiss")}</button>
      </div>
    </div>
  );
};

export default TeacherHints;
